import { render, staticRenderFns } from "./uploadPicView.vue?vue&type=template&id=4f9f36c4&scoped=true&lang=true&"
import script from "./uploadPicView.vue?vue&type=script&lang=js&"
export * from "./uploadPicView.vue?vue&type=script&lang=js&"
import style0 from "./uploadPicView.vue?vue&type=style&index=0&id=4f9f36c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f36c4",
  null
  
)

export default component.exports